/* eslint-disable */
export interface StateResults {}

export class State implements StateResults {}
